import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=3679b588&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"
import style0 from "./Environment.vue?vue&type=style&index=0&id=3679b588&prod&lang=scss&scoped=true"
import style1 from "./Environment.vue?vue&type=style&index=1&id=3679b588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679b588",
  null
  
)

export default component.exports